module.exports = __webpack_public_path__ + "static/media/Product_Management_On_Demand.f97d069b.jpg";